<template>
  <div class="modal">
    <div class="modal__content">
      <ModalContent
        @action="closeModal"
        :active="isOpen"
        :description="description"
        :actionLabel="actionLabel"
      />
    </div>
  </div>
</template>

<script>
import ModalContent from "./components/ModalContent";

export default {
  name: "Modal",
  components: {
    ModalContent
  },
  props: {
    description: {
      type: String,
      default: undefined
    },
    actionLabel: {
      type: String,
      default: undefined
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal: function() {
      this.$emit("closeModal");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: block;
}
</style>
